import { useEmblaSelectedIndex } from "@src/app/hooks/useEmblaSelectedIndex";
import { useIsClient } from "@src/app/hooks/useIsClient";
import clsx from "clsx";
import useEmblaCarousel from "embla-carousel-react";
import { type ReactElement } from "react";
import type { LinksFunction } from "react-router";

import styles from "./EmblaArticleSlider.css?url";
export const EmblaArticleSliderLinks: LinksFunction = () => [
  { rel: "stylesheet", href: styles },
];

type EmblaArticleSliderProps = { children: ReactElement[]; className?: string };

export default function EmblaArticleSlider({
  children,
  className,
}: EmblaArticleSliderProps) {
  const isClient = useIsClient();
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: true,
    dragFree: false,
    duration: 25,
    startIndex: 0,
  });

  const selectedIndex = useEmblaSelectedIndex(emblaApi);

  if (!isClient) return null;

  return (
    <>
      <div
        className={clsx(
          "visible w-full lg:hidden lg:pb-0",
          className,
          children.length === 1 ? "pb-0" : "pb-[32px]",
        )}
      >
        <div className="embla-article-slider">
          <div className="embla-article-slider__viewport" ref={emblaRef}>
            <div className="embla-article-slider__container">
              {children.map((child, index) => (
                <div className="embla-article-slider__slide" key={index}>
                  {child}
                </div>
              ))}
            </div>
          </div>

          {children.length > 1 && (
            <ul className="embla-article-slider__dots">
              {Array.from({ length: children.length }).map((_, idx) => (
                <li key={idx} className="embla-article-slider__dot">
                  <button
                    onClick={() => emblaApi?.scrollTo(idx)}
                    className={clsx(
                      "embla-article-slider__dot-button",
                      selectedIndex === idx
                        ? "embla-article-slider__dot-button--active"
                        : "",
                    )}
                  >
                    {idx + 1}
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className="hidden lg:grid lg:grid-cols-12 lg:gap-0">{children}</div>
    </>
  );
}
